export const replaceText = (text) => {
    let lowercaseText = text.toLowerCase();
    let textWithoutSpaces = lowercaseText.replace(/\s+/g, '_');    
    let textWithoutAccents = textWithoutSpaces.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    
    return textWithoutAccents;
}